<template>
  <div>
    <div class="container">
     
      <div class="row mt-5 mb-5">
        <div class="col-lg-6 ">
          <img src="/src/assets/photos/contact.png" class="img-fluid" />
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <h4 class="mb-4 text-center">WhatsApp'tan Mesaj Gönder</h4>
            <div class="form-wrapper">
              <label>Ad Soyad</label> <br />
              <input
                type="text"
                placeholder="Adınızı ve Soyadınızı Giriniz..."
                class="form-control fields "
                v-model="name"
              />
              <span></span>
            </div>
            <div class="form-wrapper">
              <label for="messages">Mesajınız</label>
              <textarea
                class="form-control fields"
                placeholder="Mesajınızı Giriniz..."
                name="messages"
                id=""
                cols="10"
                rows="5"
                v-model="messages"
              ></textarea>
              <span></span>
            </div>
          </div>
          <button
            class="btn btn-success float-right mt-2"
            @click="whatsappMessage"
          >
            Gönder
          </button>
        </div>
      </div>
      <!-- row 2 -->
      <div class="row mt-5">
        <div class="col-lg-12 col-md-12 ">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5935.212061716625!2d34.58214922547292!3d41.94431634693718!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x408f813862fac3df%3A0x8836bedf9cf3cb65!2zQXlhbmPEsWssIFlhbMSxLCA1NzQwMiBBeWFuY8Sxay9TaW5vcA!5e0!3m2!1str!2str!4v1599415961083!5m2!1str!2str"
            width="100%"
            height="450"
            frameborder="0"
            style="border:0;"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
            class="form-group"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      messages: ""
    };
  },
  methods: {
    whatsappMessage() {
      if (this.name !== "" && this.messages !== "") {
        open(
          `https://wa.me/905326158788/?text=Ad Soyad : ${this.name}  Mesaj : ${this.messages}`,
          "_blank"
        );
      } else {
        this.openNotification('top-right', 'danger');
      }
    },
     openNotification(position = null, color) {
          const noti = this.$vs.notification({
            progress: 'auto',
            color,
            position,
            title: 'UYARI!',
            text: 'Lütfen Tüm Alanları Doldurdunuz!'
          })
        }
  }
};
</script>

<style scoped>
.form-wrapper {
  border: 1px solid lightgrey;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
}

.btn-success {
  background-color: #438a5e !important;
}
.btn-success:hover {
  background-color: white !important;
  border: 1px solid #438a5e !important;
  color: #438a5e;
}

label {
  color: rgb(104, 102, 102) !important;
}
.form-control {
  border-radius: 0px !important;
}
.fields + span {
  display: block;
  border-bottom: solid 3px #38bb6a;
  width: 0;
  -webkit-transition: width 250ms ease-in-out;
  transition: width 250ms ease-in-out;
}
.fields:focus + span {
  width: 100%;
  -webkit-transition: width 250ms ease-in-out;
  transition: width 250ms ease-in-out;
}
*:focus {
  box-shadow: none !important;
  border: solid 1px lightgrey !important;
}
.form-group {
  border-radius: 10px;
  padding: 15px;
  -webkit-box-shadow: 0px 0px 75px -24px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 75px -24px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 75px -24px rgba(0, 0, 0, 0.75);
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue